import { Modal } from "@JohnLewisPartnership/jl-design-system/dist/components/modal/Modal";
import { ESIInclude } from "../../../__shared__/ESIInclude/ESIInclude";

export type M2MHelpSection = {
  name: string;
  title: string;
};

type Props = {
  sections: M2MHelpSection[];
  visibleSection: M2MHelpSection;
  isOpen: boolean;
  onClose: () => void;
};

export const MadeToMeasureHelpModal = ({
  visibleSection,
  isOpen,
  onClose,
  sections,
}: Props) => {
  return (
    <Modal
      width="large"
      footer={false}
      isOpen={isOpen}
      onClose={onClose}
      title={visibleSection.title}
    >
      {sections.map((section) => {
        return (
          <div
            key={section.name}
            style={{
              display: visibleSection.name === section.name ? "block" : "none",
            }}
          >
            <ESIInclude
              id={section.name}
              src={`/content-renderer/contextual-help/made-to-measure/${section.name}?includeCoreJS=false&includePolyfills=false`}
            />
          </div>
        );
      })}
    </Modal>
  );
};
